import { render, staticRenderFns } from "./PriorityBadge.vue?vue&type=template&id=dad26f2e"
import script from "./PriorityBadge.vue?vue&type=script&lang=js"
export * from "./PriorityBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports